<template>
  <div class="devices">
    <el-row class="device-title">
      <el-col :span="2">
        <span class="h3">{{$t('she_bei_lie_biao')}}</span>
      </el-col>
      <el-col :span="22" class="device-list-filter">
        <el-form label-width="auto" :inline="true" size="mini">

          <el-col :span="6">
            <el-form-item :label="$t('suo_shu_fen_zu')">
              <el-select :placeholder="$t('qing_xuan_ze_suo_shu_fen_zu')"
                         class="device-input-filter" v-model="pagination.groupUuid"
                         @change="loadDeviceSearch">
                <el-option v-for="item in groups"
                           :key="item.uuid"
                           :label="item.name"
                           :value="item.uuid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('di_li_wei_zhi')" label-width="auto">
              <el-cascader
                class="device-input-filter"
                size="mini"
                :options="options"
                :props="{ expandTrigger: 'hover' }"
                @change="handleAreaChange">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('she_bei_zhuang_tai')">
              <el-select :placeholder="$t('qing_xuan_ze_she_bei_zhuang_tai')" class="device-input-filter"
                         v-model="pagination.status"
                         @change="loadDeviceSearch">
                <el-option v-for="item in deviceStatusOption"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('tiao_jian_sou_suo')">
              <el-input :placeholder="$t('qing_shu_ru_she_bei_ming_cheng')" class="device-input-filter"
                        clearable
                        v-model="pagination.info"
                        @change="loadDeviceSearch"
                        prefix-icon="el-icon-search"></el-input>
            </el-form-item>

          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <div class="device-data-list">
      <el-table :data="devices">
        <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid">
        </el-table-column>
        <el-table-column :label="$t('she_bei_ming_chen')" align="center" prop="name"></el-table-column>
        <el-table-column label="IMEI" align="center" prop="imei"></el-table-column>
        <el-table-column :label="$t('suo_shu_fen_zu')" align="center" prop="groupName"></el-table-column>
        <el-table-column :label="$t('chan_pin_ming_chen')" align="center" prop="productName"></el-table-column>
        <el-table-column :label="$t('she_bei_zhuang_tai')" align="center">
          <template slot-scope="scope">
            <div class="user-info">
                            <span :class="[{ offline: scope.row.status ==1 }, { normal: scope.row.status ==2 },
                                    { warning: scope.row.status ==3 },
                                    { fault: scope.row.status ==4 }]">
                                   <span class="circle"></span> {{statusInfos[scope.row.status]}}
                                </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('she_bei_wei_zhi')" align="center">
          <template slot-scope="scope">
            <div class="user-info" v-if="scope.row.province.length >0">
              <p>{{scope.row.province}}/{{scope.row.city}}</p>
              <p>{{scope.row.address}}</p>
            </div>
            <div class="user-info" v-if="scope.row.province.length ==0">
              <span>{{$t('zan_wei_she_zhi_de_li_wei_zhi')}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!($btnCheck('device_info_set') && $btnCheck('device_drink_set') && $btnCheck('device_del'))"
          :label="$t('cao_zuo')" align="center" prop="name" min-width="224">
          <template slot-scope="scope">

            <span v-if="!$btnCheck('device_info_set')" @click="handleCommand(scope.row, scope.$index, 'delivery.device.geo')"
                  class="device-edit">{{$t('xin_xi_geng_xin')}}</span>
            <span v-if="!$btnCheck('device_drink_set')" @click="handleCommand(scope.row, scope.$index, 'delivery.devices.drink')"
                  class="device-edit">{{$t('yin_pin_pei_zhi')}}</span>

            <span v-if="!$btnCheck('device_del')" class="device-delete" @click="handleRemove(scope.row,scope.$index)">{{$t('shan_chu')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>

    <c-dialog class="dialog" :visible.sync="updateDeviceVisible" :width="'60rem'" :height="'42rem'"
              :outerClose="false"
              :title="$t('geng_xin_she_bei_wei_zhi')">
      <div class="map">
        <div class="map-info clearfix">
          <div class="map-info-input">
            <p class="info">
              <span>{{$t('she_bei_ming_chen')}}:</span>
              <el-input v-model="device.name"></el-input>
            </p>

            <p class="info">
              <span>{{$t('she_bei_suo_ding')}}:</span>
              <el-switch v-model="device.block"></el-switch>
            </p>
            <p class="info">
              <span>{{$t('xuan_qu_di_li_wei_zhi')}}:</span>{{device.province}}{{device.city}}{{device.address}}
            </p>
          </div>
          <div class="map-info-commit">
            <el-button type="primary" @click="handleDeviceUpdate">{{$t('bao_cun')}}</el-button>
          </div>
        </div>
        <div id="allmap" class="map-container"></div>
      </div>
    </c-dialog>
  </div>

</template>

<script>
  import {provinceAndCityDataPlus, CodeToText} from 'element-china-area-data'
  import {deviceUnion, deviceList, devicePositionUpdate, deviceDelete} from '@/api/delivery/device/list'
  import {groupAll} from '@/api/delivery/organization/group'
  import CDialog from '@/components/Dialog'


  import i18n from '@/i18n/i18n'

  export default {
    name: '',
    components: {
      CDialog
    },
    mounted: function () {
      this.loadDevice()
      this.loadGroup()
    },
    data: function () {
      let devOpts = [
        {label: '所有设备', value: 0},
        {label: '离线', value: 1},
        {label: '在线', value: 2},
      ]
      switch (i18n.locale) {
        case 'en':
          devOpts = [
            {label: 'All', value: 0},
            {label: 'Offline', value: 1},
            {label: 'Online', value: 2},
          ]
          break;
      }

      return {
        options: provinceAndCityDataPlus,
        devices: [],
        deviceStatusOption: devOpts,
        pagination: {
          productUuid: '',
          info: '',
          status: 0,
          province: '',
          city: '',
          start: 0,
          curPage: 1,
          limit: 10,
          total: 0,
        },
        device: {
          uuid: '',
          name: '',
          province: '',
          city: '',
          address: '',
          lat: '',
          lng: '',
          block: false,

        },
        groups: [],
        updateDeviceVisible: false,
        deviceIndex: 0,
        statusInfos: ['未知', this.$t('li_xian'), this.$t('zheng_chang_yun_xing')]
      }
    },
    filters: {
      filterName(status) {
        switch (status) {
          case 1:
            return '离线'
          case 2:
            return '正常运行'
          case 3:
            return '待维护'
          case 4:
            return '待维修'
        }
      },
    },
    methods: {
      handleCommand(row, index, command) {
        switch (command) {
          case 'delivery.devices.drink':
            this.$router.push({name: command, params: row})
            break;
          case 'delivery.device.geo':
            this.loadMap(row, index)
            break;
        }
      },
      handleRemove(row, index) {
        this.$confirm(this.$t('delete_device_alarm_info'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          let vue = this
          deviceDelete({uuid: row.uuid}).then(res => {
            vue.$message.success(this.$t('shan_chu_cheng_gong'))
            vue.devices.splice(index, 1)
          })


        }).catch(() => {

        })
      },
      loadGroup() {
        groupAll().then(res => {
          this.groups = [{name: '全部', uuid: ''}].concat(res.data || [])
        })
      },
      handleAreaChange(value) {
        this.pagination.city = ''
        if (!value[0].length) {
          this.pagination.province = ''
          this.pagination.city = ''
        } else {
          this.pagination.province = CodeToText[value[0]]
          if (value[1].length) {
            let city = CodeToText[value[1]]
            if (city !== '全部') {
              this.pagination.city = city
            }
          }
        }
        this.loadDeviceSearch()
      },

      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        deviceList(this.pagination).then(res => {
          this.devices = res.data || []
        })
      },
      loadDevice() {
        let vue = this
        deviceUnion(this.pagination).then(res => {
          vue.devices = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
      loadDeviceSearch() {
        let vue = this
        this.pagination.curPage = 1
        this.pagination.start = 0
        deviceUnion(this.pagination).then(res => {
          vue.devices = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },

      loadMap(device, index) {
        let vue = this
        vue.deviceIndex = index
        this.device.block = device.lock === 1 || device.lock === true
        for (let item in device) {
          if (this.device.hasOwnProperty(item)) {
            this.device[item] = device[item]
          }
        }
        this.updateDeviceVisible = true
        setTimeout(function () {
          var mk = null
          let map = new BMap.Map("allmap", {enableMapClick: false});
          if (vue.device.lat !== '') {
            let lat = parseFloat(vue.device.lat)
            let lng = parseFloat(vue.device.lng)
            var pt = new BMap.Point(lng, lat);
            mk = new BMap.Marker(pt)
            map.addOverlay(mk);
            map.centerAndZoom(pt, 16);
          } else {
            var point = new BMap.Point(116.404, 39.915);
            map.centerAndZoom(point, 11);
            new BMap.LocalCity().get(function (result) {
              map.setCenter(result.name);
            });
          }
          map.enableScrollWheelZoom(true);
          map.addControl(new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_LEFT}));
          map.addControl(new BMap.NavigationControl());

          var myGeo = new BMap.Geocoder();

          map.addEventListener("click", function (e) {
            var pt = e.point;
            myGeo.getLocation(pt, function (rs) {
              vue.device.province = rs.addressComponents.province
              vue.device.city = rs.addressComponents.city
              vue.device.address = rs.addressComponents.district + rs.addressComponents.street
              vue.device.lat = rs.point.lat
              vue.device.lng = rs.point.lng
              if (mk !== null) {
                map.removeOverlay(mk)
              }
              mk = new BMap.Marker(pt)
              map.addOverlay(mk);

            })
          })
        }, 50)
      },

      handleDeviceUpdate() {
        if (this.device.name === ``) {
          this.$message.error(this.$t('qing_wan_shan_she_bei_ming_cheng'))
          return
        }

        if (this.device.province === ``) {
          this.$message.error(this.$t('qing_she_ding_she_bei_suo_zai_wei_zhi'))
          return
        }

        let vue = this
        this.device.lat = this.device.lat + ''
        this.device.lng = this.device.lng + ''
        this.device.lock = this.device.block ? 1 : 0

        devicePositionUpdate(this.device).then(() => {
          let device = vue.devices[vue.deviceIndex]
          device.name = vue.device.name
          device.province = vue.device.province
          device.city = vue.device.city
          device.address = vue.device.address
          vue.updateDeviceVisible = false
          vue.devices[vue.deviceIndex].lock = vue.device.lock
          vue.$message.success(vue.$t('geng_xin_cheng_gong'))
        })
      },

    },
  }
</script>

<style lang="scss">
  .devices {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .device-title {
      .device-input-filter {
        input {
          border: none;
          border-bottom: 1px solid $f_fiv_color;
          font-size: $filter-font-size;
          border-radius: 0;
        }
      }

      .mini {
        .el-form-item__content {
          width: 60%;
        }
      }
    }

    .device-data-list {
      margin-top: $padding;
      flex: 1;

      .device-info {
        .device-info-img {
        }

        .device-info-detail {

          p {
            margin-bottom: $padding-5;
          }

          p:first-child {
            font-size: .8rem;
          }
        }
      }

      .el-table {
        thead {
          tr {
            th {
              border-bottom: 1px solid $border_sec_color;
            }
          }
        }

      }

      .user-info {
        p:first-child {
          margin-bottom: $padding-5;
        }
      }

      .el-table--group::after, .el-table--border::after, .el-table::before {
        background-color: transparent;
      }

      .el-table__row:hover {
        background-color: $bg_sec_color;
      }

      .device-edit, .device-delete {
        cursor: pointer;
        display: inline-block;
        margin-right: $padding;
      }

      .device-edit:hover, .device-delete:hover {
        color: $f_color;
      }

      .device-edit {
        color: $btn_color;
      }

      .device-delete {
        color: $btn_sec_color;
      }

      .circle {
        border-radius: $small_font_size;
        width: $small_font_size;
        height: $small_font_size;
        display: inline-block;
        margin-right: 5px;
      }

      .offline {
        color: #5B8FF9;

        .circle {
          background-color: #5B8FF9;
        }
      }

      .normal {
        color: #5AD8A6;

        .circle {
          background-color: #5AD8A6;
        }
      }

      .warning {
        color: #F6BD16;

        .circle {
          background-color: #F6BD16;
        }
      }

      .fault {
        color: #E8684A;

        .circle {
          background-color: #E8684A;
        }
      }

    }

    .dialog {
      .map {
        text-align: left;

        .map-container {
          height: 465px;
        }

        .anchorBL {
          display: none;
        }

        .map-info {
          margin-bottom: 10px;

          .map-info-input {
            float: left;
            width: 80%;

            .info {
              margin-bottom: 10px;

              span {
                display: inline-block;
                text-align: right;
                width: 120px;
                margin-right: 10px;
                color: $f_sec_color;
                font-size: .6rem;
              }

              .el-input {
                max-width: 320px;
              }
            }

          }

          .map-info-commit {
            float: left;
            width: 20%;
            margin-top: 16px;
            text-align: center;
          }

        }
      }
    }

    .pagination {
      margin: $padding;
    }
  }

</style>
